import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../modals/modalReducer";

export default function MaintenanceOverlay({ notice }) {
    const dispatch = useDispatch();

    if (!notice || notice.type !== "maintenance" || !notice.message) return null;

    const endsAt = notice.ends_at ? new Date(notice.ends_at) : null;
    const endsAtText = endsAt && !Number.isNaN(endsAt.getTime()) ? endsAt.toLocaleString() : "";

    return (
        <div className="fixed inset-0 z-40 bg-white flex items-center justify-center">
            <div className="max-w-2xl w-full px-6">
                <div className="border border-gray-200 rounded-lg shadow-lg p-6">
                    <h1 className="text-2xl font-semibold text-gray-900 mb-3">System Maintenance</h1>
                    <p className="text-gray-700 whitespace-pre-wrap">{notice.message}</p>
                    {endsAtText ? <p className="mt-4 text-sm text-gray-500">Expected back: {endsAtText}</p> : null}

                    <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
                        <p className="text-sm text-gray-500">
                            If this is urgent, please contact Lakato support.
                            <br />
                            Admins can still log in to verify and disable maintenance.
                        </p>

                        <button
                            type="button"
                            className="px-4 py-2 rounded bg-lk_grey_one hover:bg-lk_dark_grey_button_hover text-white text-sm uppercase"
                            onClick={() => dispatch(openModal({ modalType: "ModalLogin", modalProps: {} }))}
                        >
                            Admin Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
